import React from "react";
import { observer } from "mobx-react";
import { AuthorPublisherUpdateStore } from "../../store";
import { AuthorPublisherUpdateForm } from "./AuthorPublisherUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type AuthorPublisherUpdateProps = {
  authorPublisherUpdateStore: AuthorPublisherUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const AuthorPublisherUpdate: React.FC<AuthorPublisherUpdateProps> =
  observer(
    ({ authorPublisherUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={authorPublisherUpdateStore.isSaving} />
          <AuthorPublisherUpdateForm
            authorPublisherUpdateStore={authorPublisherUpdateStore}
            publisherError={
              authorPublisherUpdateStore.errors.publisher?.message
            }
            onPublisherChange={(value) => {
              authorPublisherUpdateStore.setPublisherValue(value);
            }}
            publisherSelectedValue={
              authorPublisherUpdateStore.entityValues.showPublisher
            }
            onPublisherSelected={(value) => {
              authorPublisherUpdateStore.setSelectedPublisher(value);
            }}
            publisherOptions={authorPublisherUpdateStore.getPublisherOptions()}
            percentageError={
              authorPublisherUpdateStore.errors.percentage?.message
            }
            onPercentageChange={(value: number) => {
              authorPublisherUpdateStore.setPercentageValue(value);
            }}
            percentage={authorPublisherUpdateStore.entityValues.percentage}
            durationInYearsError={
              authorPublisherUpdateStore.errors.durationInYears?.message
            }
            onDurationInYearsChange={(value: number | undefined) => {
              authorPublisherUpdateStore.setDurationInYearsValue(value);
            }}
            durationInYears={
              authorPublisherUpdateStore.entityValues.durationInYears
            }
            autoRenewalYearsError={
              authorPublisherUpdateStore.errors.autoRenewalYears?.message
            }
            onAutoRenewalYearsChange={(value: number | undefined) => {
              authorPublisherUpdateStore.setAutoRenewalYearsValue(value);
            }}
            autoRenewalYears={
              authorPublisherUpdateStore.entityValues.autoRenewalYears
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={authorPublisherUpdateStore.saveDisabled}
            onSave={() => authorPublisherUpdateStore.saveAuthorPublisher()}
            onCancel={() => authorPublisherUpdateStore.cancelAuthorPublisher()}
          />
          <ErrorDialog
            open={authorPublisherUpdateStore.errorDialogOpened}
            title={authorPublisherUpdateStore.errorTitle}
            description={authorPublisherUpdateStore.errorDescription}
            onClose={() => authorPublisherUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={authorPublisherUpdateStore.confirmDialogOpened}
            title={authorPublisherUpdateStore.confirmDialogTitle}
            description={authorPublisherUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              authorPublisherUpdateStore.executeConfirmedAction()
            }
            onCancel={() => authorPublisherUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
